import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const availableMarketValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const isElectricity = control.get('isElectricity');
  const isGas = control.get('isGas');

  var validatorResponse = (isElectricity?.value.length > 0 || isGas?.value.length > 0) ? null : { noAvailablemarketChecked: true }
  return validatorResponse;
};